module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/images/background.b458456b.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/images/background.jpg
// module id = 2823
// module chunks = 11